import { useState, useEffect, useContext } from 'react';

import { DataContext } from 'providers/data';
import { DataTypesOfScheduling } from 'core/typesOfScheduling';
import { ParamsDataOrdersByCustomerId } from 'utils/typeServices';

import Modals from 'components/views/Modals';
import NavTitle from 'components/views/NavTitle';
import Select from 'components/views/form/Select';
import FadeAnimation from 'components/views/FadeAnimation';
import { Typography, Box, Collapse } from '@mui/material';
import { ButtonRectangle } from 'components/views/form/Button';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { TypographyLight, BoxCase, Label, ProcedureCard, BoxSvg } from 'pages/Scheduling/styles';

type ParamsTypeCompletedScheduling = {
    NR_TIPO_AGENDAMENTO: number;
    DS_TIPO_AGENDAMENTO: string;
    NR_PLATAFORMA: number;
    DS_PLACA: string;
    listCompletedScheduling: Array<ParamsDataOrdersByCustomerId>;
}

type ParamsSchedulingMobile = {
    NR_TIPO_AGENDAMENTO: number;
    DS_TIPO_AGENDAMENTO: string;
    isLoadingDownloadMobile: boolean;
    handleTermoDeAdesao: (CD_AGENDAMENTO: number) => void;
    listCompletedScheduling: Array<ParamsDataOrdersByCustomerId>;
}

const ContentMobile = ({ NR_TIPO_AGENDAMENTO, DS_TIPO_AGENDAMENTO, handleTermoDeAdesao, isLoadingDownloadMobile, listCompletedScheduling }: ParamsSchedulingMobile) => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <Box sx={{ display: { xs: 'block', md: 'none' }, marginTop: '1rem' }}>
            <Box sx={{ display: 'flex', borderBottom: '1px solid #8D9BB5', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={() => setShowDetails(!showDetails)}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 600 }}>
                    {DS_TIPO_AGENDAMENTO}
                </Typography>
                <BoxSvg className={showDetails ? 'show' : 'hide'}>
                    <ExpandMoreIcon fontSize='medium' />
                </BoxSvg>
            </Box>

            <Collapse in={showDetails}>
                {listCompletedScheduling.map(({ DT_INICIO, NM_ENDERECO, NR_NUMERO, NM_BAIRRO, NM_CIDADE, DS_STATUS, NR_STATUS, DATA_PEDIDO, NM_LOJA, NM_PRODUTO, CD_AGENDAMENTO }, index) =>
                    <Box sx={{ paddingTop: '1rem' }} key={index}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '0 2px', gap: '7%' }}>
                            <BoxCase sx={{ backgroundColor: NR_STATUS === 4 ? 'secondary.main' : 'transparent', width: '100%' }}>
                                <Typography fontSize='.9375rem' color={NR_STATUS === 4 ? 'white' : 'grey.400'}>
                                    Status: <strong>{DS_STATUS}</strong>
                                </Typography>
                            </BoxCase>
                        </Box>

                        <Box sx={{ display: 'grid', rowGap: '1.375rem', columnGap: '10%', padding: '1.25rem .375rem', marginTop: '1.25rem', backgroundColor: 'rgba(141, 155, 181, 0.1)' }}>
                            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'auto auto', md: '1fr 1fr' } }}>
                                <Label>
                                    <p className='title'>
                                        Data do agendamento
                                    </p>
                                    <p className='description'>
                                        {new Date(DT_INICIO).toLocaleDateString('pt-BR')}<br />
                                        {new Date(DT_INICIO).toLocaleTimeString()}
                                    </p>
                                </Label>

                                <Label>
                                    {NM_PRODUTO &&
                                        <>
                                            <p className='title'>
                                                Produto
                                            </p>
                                            <p className='description'>
                                                {NM_PRODUTO}
                                            </p>
                                        </>
                                    }
                                </Label>
                            </Box>

                            <Label>
                                <p className='title'>
                                    Loja agendamento
                                </p>
                                <p className='description' style={{ lineHeight: '1.3rem' }}>
                                    {NM_LOJA} <br />
                                    {NM_ENDERECO}, {NR_NUMERO}, {NM_BAIRRO}, {NM_CIDADE}
                                </p>
                            </Label>

                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                                <Label>
                                    <p className='title'>
                                        Data do pedido
                                    </p>
                                    <p className='description'>
                                        {new Date(DATA_PEDIDO).toLocaleDateString('pt-BR')}<br />
                                        {new Date(DATA_PEDIDO).toLocaleTimeString()}
                                    </p>
                                </Label>
                                <Label>
                                    <p className='title'>
                                        Documento/Termo
                                    </p>
                                    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                                        <p className='description' onClick={() => handleTermoDeAdesao(CD_AGENDAMENTO)}>
                                            DOWNLOAD
                                        </p>
                                        {isLoadingDownloadMobile &&
                                            <CircularProgress sx={{ marginTop: '.2rem', width: '1.25rem !important', height: '1.25rem !important', 'svg': { marginLeft: '0', height: 'auto' } }} />
                                        }
                                    </Box>
                                </Label>

                            </Box>
                        </Box>
                        {index < (listCompletedScheduling.length - 1) &&
                            <Box sx={{ width: '95%', height: '1px', backgroundColor: 'grey.400', margin: '1rem auto 0' }} />
                        }
                    </Box>
                )}
            </Collapse>
        </Box>
    )
}

type Params = {
    listCompletedScheduling: Array<ParamsDataOrdersByCustomerId>;
}

type ParamsListCars = {
    text: string;
    value: string;
}

const CompletedScheduling = ({ listCompletedScheduling }: Params) => {
    const [showModalError, setShowModalError] = useState(false);
    const [listCars, setListCars] = useState<Array<ParamsListCars>>();
    const [carSelected, setCarSelected] = useState({
        text: '',
        value: ''
    });
    const [selectedProcedure, setProcedureSelected] = useState(0);
    const [isLoadingDownload, setIsLoadingDownload] = useState(false);
    const [typeCompletedScheduling, setTypeCompletedScheduling] = useState<Array<ParamsTypeCompletedScheduling>>([]);
    const { customerCars, dataBuscaTermoDeAdesao, handlePostBuscaTermoDeAdesao } = useContext(DataContext);

    const handlePostBuscaTermoDeAdesaoState = (CD_AGENDAMENTO: number) => {
        setIsLoadingDownload(true);
        handlePostBuscaTermoDeAdesao({ token: localStorage.getItem('token')!, CD_AGENDAMENTO });
    }

    useEffect(() => {
        if (listCompletedScheduling && customerCars) {
            let listCarsAux: Array<ParamsListCars> = [];

            listCompletedScheduling.map(({ DS_PLACA, NR_PLATAFORMA, DS_CHASSI }, index) => (listCarsAux?.findIndex(({ text }) => text === (DS_PLACA || DS_CHASSI)) === -1) && listCarsAux.push({ text: DS_PLACA || DS_CHASSI, value: `${NR_PLATAFORMA}` }));

            setListCars(listCarsAux);
            setCarSelected(listCarsAux[0]);

            let typeCompletedSchedulingAux: Array<ParamsTypeCompletedScheduling> = [];

            listCompletedScheduling.forEach((scheduling) => {
                const schedulingIndex = typeCompletedSchedulingAux.findIndex(({ NR_TIPO_AGENDAMENTO, NR_PLATAFORMA }) => ((NR_TIPO_AGENDAMENTO === scheduling.NR_TIPO_AGENDAMENTO) && (NR_PLATAFORMA === scheduling.NR_PLATAFORMA)));

                if (schedulingIndex >= 0) {
                    typeCompletedSchedulingAux[schedulingIndex].listCompletedScheduling.push(scheduling);
                } else {
                    typeCompletedSchedulingAux.push({
                        DS_TIPO_AGENDAMENTO: scheduling.DS_TIPO_AGENDAMENTO,
                        NR_TIPO_AGENDAMENTO: scheduling.NR_TIPO_AGENDAMENTO,
                        NR_PLATAFORMA: scheduling.NR_PLATAFORMA,
                        DS_PLACA: scheduling.DS_PLACA,
                        listCompletedScheduling: [scheduling]
                    });
                }
            });

            typeCompletedSchedulingAux && setTypeCompletedScheduling(typeCompletedSchedulingAux);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listCompletedScheduling, customerCars]);

    useEffect(() => {
        dataBuscaTermoDeAdesao !== undefined && setIsLoadingDownload(false);
        dataBuscaTermoDeAdesao === false && setShowModalError(true);
    }, [dataBuscaTermoDeAdesao]);

    return (
        <FadeAnimation>
            <Box paddingTop='.3125rem'>
                <NavTitle title='Veículo selecionado' />
                <Box sx={{ margin: '.5625rem 0 1.5625rem', maxWidth: '13.375rem' }}>
                    {listCars &&
                        <Select
                            disabled={false}
                            itemSelected={carSelected}
                            listItems={listCars}
                            onChangeSelected={(e) => {
                                setCarSelected(e);
                                setProcedureSelected(listCars?.findIndex(({ value }) => e.value === value))
                            }}
                        />
                    }
                </Box>
                <TypographyLight sx={{ marginBottom: '4px' }}>
                    Tipo:
                </TypographyLight>
                <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                    {typeCompletedScheduling && typeCompletedScheduling.map(({ NR_PLATAFORMA, NR_TIPO_AGENDAMENTO, DS_TIPO_AGENDAMENTO, listCompletedScheduling }, index) =>
                        NR_PLATAFORMA === parseFloat(carSelected.value) &&
                        <ContentMobile
                            NR_TIPO_AGENDAMENTO={NR_TIPO_AGENDAMENTO}
                            DS_TIPO_AGENDAMENTO={DS_TIPO_AGENDAMENTO}
                            listCompletedScheduling={listCompletedScheduling}
                            key={index}
                            handleTermoDeAdesao={(CD_AGEND) => handlePostBuscaTermoDeAdesaoState(CD_AGEND)}
                            isLoadingDownloadMobile={isLoadingDownload}
                        />
                    )}
                </Box>

                <Box sx={{ display: { xs: 'none', md: 'grid' }, gridTemplateColumns: '13.75rem 1fr' }}>
                    <Box sx={{ borderRight: '2px solid #8D9BB5', padding: '0 1.25rem 0 0' }}>
                        {typeCompletedScheduling.map(({ NR_TIPO_AGENDAMENTO, NR_PLATAFORMA }, index) =>
                            NR_PLATAFORMA === parseFloat(carSelected.value) &&
                            <Box key={index} sx={{ borderBottom: '1px solid #D9D9D9', padding: '.625rem 0', cursor: 'pointer' }} onClick={() => setProcedureSelected(index)}>
                                <ProcedureCard sx={{
                                    backgroundColor: selectedProcedure === index ? 'rgba(141, 155, 182, 0.15)' : 'transparent',
                                    'svg': {
                                        opacity: selectedProcedure === index ? '1' : '0'
                                    }
                                }}>
                                    <Typography fontWeight={600} fontSize='1rem' paddingTop='4px'>
                                        {DataTypesOfScheduling(NR_TIPO_AGENDAMENTO)}
                                    </Typography>
                                    <KeyboardArrowRightIcon />
                                </ProcedureCard>
                            </Box>
                        )}
                    </Box>

                    <Box sx={{ overflowY: 'auto', maxHeight: '59vh' }}>
                        {typeCompletedScheduling && typeCompletedScheduling[selectedProcedure]?.listCompletedScheduling?.map(({ NR_STATUS, DS_STATUS, NM_LOJA, DT_FIM, DT_INICIO, NM_PRODUTO, DATA_PEDIDO }, index) =>
                            <Box sx={{ padding: '9px 0 0 1.625rem', minHeight: '400px' }} key={index}>
                                <Box sx={{ display: 'flex', gap: '2.1875rem' }}>
                                    <BoxCase sx={{ border: NR_STATUS === 4 ? 'none' : '1px solid #8D9BB5', backgroundColor: NR_STATUS === 4 ? 'secondary.main' : 'transparent', width: '39%', maxWidth: '13.75rem' }}>
                                        <Typography fontSize='.9375rem' color={NR_STATUS === 4 ? 'white' : 'grey.400'}>
                                            Status: <strong>{DS_STATUS}</strong>
                                        </Typography>
                                    </BoxCase>
                                </Box>

                                <Box sx={{ padding: { xs: '1.25rem 0', md: '1.5625rem 0' } }}>
                                    <TypographyLight sx={{ marginBottom: '.3125rem' }}>
                                        Informações do agendamento:
                                    </TypographyLight>
                                    <Box sx={{ display: 'grid', rowGap: '1.375rem', columnGap: '10%', padding: '1.5rem 1.25rem', backgroundColor: 'rgba(141, 155, 181, 0.1)' }}>
                                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'auto auto', md: '1fr 1fr 1fr' } }}>
                                            {DT_FIM &&
                                                <Label>
                                                    <p className='title'>
                                                        Data do agendamento
                                                    </p>
                                                    <p className='description'>
                                                        {new Date(DT_INICIO).toLocaleDateString('pt-BR')}<br />
                                                        {new Date(DT_INICIO).toLocaleTimeString()}
                                                    </p>
                                                </Label>
                                            }

                                            <Label sx={{ display: { xs: 'none', md: 'block' } }}>
                                                <p className='title'>
                                                    Data do pedido
                                                </p>
                                                <p className='description'>
                                                    {new Date(DATA_PEDIDO).toLocaleDateString('pt-BR')}<br />
                                                    {new Date(DATA_PEDIDO).toLocaleTimeString()}
                                                </p>
                                            </Label>

                                            <Label>
                                                {NM_PRODUTO &&
                                                    <>
                                                        <p className='title'>
                                                            Produto
                                                        </p>
                                                        <p className='description'>
                                                            {NM_PRODUTO}
                                                        </p>
                                                    </>
                                                }
                                            </Label>
                                        </Box>

                                        {NM_LOJA &&
                                            <Label>
                                                <p className='title'>
                                                    Loja agendamento
                                                </p>
                                                <p className='description' style={{ lineHeight: '1.3rem' }}>
                                                    {listCompletedScheduling[selectedProcedure]?.NM_LOJA}<br />
                                                    {listCompletedScheduling[selectedProcedure]?.NM_ENDERECO}, {listCompletedScheduling[selectedProcedure]?.NR_NUMERO}, {listCompletedScheduling[selectedProcedure]?.NM_BAIRRO}, {listCompletedScheduling[selectedProcedure]?.NM_CIDADE}
                                                </p>
                                            </Label>
                                        }

                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', '.description': { cursor: 'pointer' } }}>
                                            <Label>
                                                <p className='title'>
                                                    Documento/Termo
                                                </p>
                                                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                                                    <p className='description' onClick={() => handlePostBuscaTermoDeAdesaoState(listCompletedScheduling[selectedProcedure]?.CD_AGENDAMENTO)}>
                                                        DOWNLOAD
                                                    </p>
                                                    {isLoadingDownload &&
                                                        <CircularProgress sx={{ marginTop: '.2rem', width: '1.3rem !important', height: '1.3rem !important', 'svg': { marginLeft: '0', height: 'auto' } }} />
                                                    }
                                                </Box>
                                            </Label>
                                        </Box>
                                    </Box>
                                </Box>
                                {index < (typeCompletedScheduling[selectedProcedure].listCompletedScheduling.length - 1) &&
                                    <Box sx={{ height: '1px', backgroundColor: 'grey.400', margin: '0 auto' }} />
                                }
                            </Box>
                        )}
                    </Box>
                </Box>

                <Modals open={showModalError}>
                    <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '20rem' } }}>
                        <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1.375rem 1.25rem'>
                            <Typography fontSize='1.5625rem' fontWeight={700} textAlign='center'>
                                AVISO
                            </Typography>
                            <Typography fontSize='1rem' lineHeight='19px' paddingTop='1rem' textAlign='center'>
                                Não foi possível localizar o <br /> <b>termo de adesão.</b>
                            </Typography>
                        </Box>

                        <Box sx={{
                            backgroundColor: 'primary.main',
                            borderRadius: '0 0 8px 8px',
                            padding: {
                                xs: '1rem 2.5rem 1.625rem',
                                md: '1.875rem 2rem 1.625rem'
                            },
                            'button': {
                                width: '12.5rem',
                                height: '2.5rem'
                            }
                        }}>
                            <ButtonRectangle name='Fechar' onClick={() => setShowModalError(false)} />
                        </Box>
                    </Box>
                </Modals>
            </Box>
        </FadeAnimation>
    );
}

export default CompletedScheduling;